import { gql } from 'apollo-boost';

export const OrderCountToStts = gql`
  query OrderCountToStts($shopId: Int!) {
    orderCountToStts(shopId: $shopId) {
      ordrStts
      count
      totalAmount
    }
  }
`;

export const OrderToStts = gql`
  query OrderToStts($shopId: Int!, $ordrStts: String, $startDay: String, $endDay: String, $limit: Int, $offset: Int) {
    orderToStts(shopId: $shopId, ordrStts: $ordrStts, startDay: $startDay, endDay: $endDay, limit: $limit, offset: $offset) {
      ordrNo
      shopId
      ordrStts
      acceptNum
      ordrAt
      payAt
      acceptAt
      productEndAt
      shopTblId
      tblNm
      ordrType
      payYn
      payAmt
      menuCount
      memoTakeout
      purchaseType
      ordrItems {
        ordrItemNo
        ordrNo
        userOrdrId
        shopId
        ordrItemAmt
        ordrItemNm
        ordrItemQty
        regAt
        menuPrice
        menuPriceNm
        ordrItemTotAmt
        payPeop
        ordrOptGrps {
          ordrOptGrpId
          ordrItemNo
          ordrNo
          shopId
          ordrOptGrpNm
          regAt
          ordrOptItems {
            ordrOptId
            ordrOptGrpId
            ordrNo
            shopId
            ordrOptPrice
            ordrOptQty
            ordrOptNm
            regAt
          }
        }
      }
    }
  }
`;

export const KioOrderToStts = gql`
  query KioOrderToStts($shopId: Int!, $ordrStts: String, $startDay: String, $endDay: String, $limit: Int, $offset: Int) {
    kioOrderToStts(shopId: $shopId, ordrStts: $ordrStts, startDay: $startDay, endDay: $endDay, limit: $limit, offset: $offset) {
      ordrNo
      shopId
      ordrStts
      acceptNum
      ordrAt
      payAt
      acceptAt
      productEndAt
      shopTblId
      tblNm
      ordrType
      payYn
      payAmt
      menuCount
      memoTakeout
      purchaseType
      ordrItems {
        ordrItemNo
        ordrNo
        userOrdrId
        shopId
        ordrItemAmt
        ordrItemNm
        ordrItemQty
        regAt
        menuPrice
        menuPriceNm
        ordrItemTotAmt
        payPeop
        ordrOptGrps {
          ordrOptGrpId
          ordrItemNo
          ordrNo
          shopId
          ordrOptGrpNm
          regAt
          ordrOptItems {
            ordrOptId
            ordrOptGrpId
            ordrNo
            shopId
            ordrOptPrice
            ordrOptQty
            ordrOptNm
            regAt
          }
        }
      }
    }
  }
`;

export const UpdateOrderStts = gql`
  mutation UpdateOrderStts($ordrNo: Int!, $ordrStts: String!) {
    updateOrderStts(ordrNo: $ordrNo, ordrStts: $ordrStts) {
      ordrNo
      ordrStts
      acceptNum
      acceptAt
      payAt
      productEndAt
      shopTblId
      tblNm
      ordrType
      payYn
      payAmt
      menuCount
      ordrItems {
        ordrItemNo
        ordrNo
        userOrdrId
        shopId
        ordrItemAmt
        ordrItemNm
        ordrItemQty
        regAt
        menuPrice
        menuPriceNm
        ordrItemTotAmt
        payPeop
        ordrOptGrps {
          ordrOptGrpId
          ordrItemNo
          ordrNo
          shopId
          ordrOptGrpNm
          regAt
          ordrOptItems {
            ordrOptId
            ordrOptGrpId
            ordrNo
            shopId
            ordrOptPrice
            ordrOptQty
            ordrOptNm
            regAt
          }
        }
      }
    }
  }
`;

export const OrderAcceptWaiting = gql`
  subscription OrderAcceptWaiting($shopId: Int!) {
    orderAcceptWaiting(shopId: $shopId) {
      ordrNo
      shopId
      ordrStts
      acceptNum
      ordrAt
      payAt
      acceptAt
      productEndAt
      shopTblId
      tblNm
      ordrType
      payYn
      payAmt
      menuCount
      memoTakeout
      purchaseType
      ordrItems {
        ordrItemNo
        ordrNo
        userOrdrId
        shopId
        ordrItemAmt
        ordrItemNm
        ordrItemQty
        regAt
        menuPrice
        menuPriceNm
        ordrItemTotAmt
        payPeop
        ordrOptGrps {
          ordrOptGrpId
          ordrItemNo
          ordrNo
          shopId
          ordrOptGrpNm
          regAt
          ordrOptItems {
            ordrOptId
            ordrOptGrpId
            ordrNo
            shopId
            ordrOptPrice
            ordrOptQty
            ordrOptNm
            regAt
          }
        }
      }
    }
  }
`;

export const PayListForOrdr = gql`
  query PayListForOrdr($ordrNo: Int!) {
    payListForOrdr(ordrNo: $ordrNo) {
      pay {
        payNo
        ordrNo
        userOrdrId
        shopId
        shopTblId
        payAmt
        payMethod
        payMethodDispNm
        payStts
        payAprvNo
        payAprvResAt
        regDtm
        modDtm
        authYn
        trDt
        trTm
        authNum
        msgOne
        msgTwo
        issCd
        aquCd
        halbu
        ordrSumr
      }
      order {
        userNick
      }
    }
  }
`;

export const CancelPay = gql`
  mutation CancelPay($payNo: Int!, $purchaseType: String!) {
    cancelPay(payNo: $payNo, purchaseType: $purchaseType)
  }
`;

// 전체 결제 취소
export const CancelPayAll = gql`
  mutation CancelPayAll($ordrNo: Int!) {
    cancelPayAll(ordrNo: $ordrNo)
  }
`;
